import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  style: {"line-height":"20px !important"},
  "nav-title": ""
}
const _hoisted_2 = {
  key: 0,
  style: {"padding-right":"6px"},
  "m-tb-0": ""
}
const _hoisted_3 = { class: "App-Startup-D-H" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_app_bottom_nav = _resolveComponent("app-bottom-nav")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_startupPageHeader = _resolveComponent("startupPageHeader")!
  const _component_appStartupOpp = _resolveComponent("appStartupOpp")!
  const _component_OpportunityBulb = _resolveComponent("OpportunityBulb")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_app_section_divider = _resolveComponent("app-section-divider")!
  const _component_app_truncate = _resolveComponent("app-truncate")!
  const _component_app_user_section = _resolveComponent("app-user-section")!
  const _component_appStartupUsersList = _resolveComponent("appStartupUsersList")!
  const _component_BusinessUpdateModal = _resolveComponent("BusinessUpdateModal")!
  const _component_app_business_right_nav = _resolveComponent("app-business-right-nav")!
  const _component_app_opportunities_list_nav = _resolveComponent("app-opportunities-list-nav")!
  const _component_app_right_nav = _resolveComponent("app-right-nav")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_app_main_layout, { class: "App-Startup-Page" }, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    "bottom-nav": _withCtx(() => [
      _createVNode(_component_app_bottom_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: false }, _createSlots({
        left: _withCtx(() => [
          false
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                plain: "",
                circle: "",
                "is-all-borderless": "",
                icon: "el-icon-back"
              }))
            : _createCommentVNode("", true)
        ]),
        center: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            (_ctx.business !== undefined)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_ctx.business.name) + "'s ", 1))
              : _createCommentVNode("", true),
            _cache[1] || (_cache[1] = _createElementVNode("div", null, [
              _createElementVNode("span", {
                "mute-secondary": "",
                style: {"font-weight":"500","font-size":"14px"}
              }, " Profile ")
            ], -1))
          ])
        ]),
        _: 2
      }, [
        (_ctx.business !== undefined && _ctx.user)
          ? {
              name: "right",
              fn: _withCtx(() => [
                _createVNode(_component_el_dropdown, { onCommand: _ctx.handleCommand }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, {
                          command: "edit",
                          icon: "el-icon-edit"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode(" Edit Startup Profile ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          command: "editFuture",
                          icon: "el-icon-edit"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode(" Startup Future ", -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, {
                          command: "cofounders",
                          icon: "el-icon-edit"
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode(" Co-founders Profiles ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      icon: "el-icon-more",
                      round: ""
                    })
                  ]),
                  _: 1
                }, 8, ["onCommand"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1024)
    ]),
    middle: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_startupPageHeader, {
          business: _ctx.business,
          loading: _ctx.loading
        }, null, 8, ["business", "loading"]),
        (_ctx.business !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createVNode(_component_app_user_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_appStartupOpp, {
                        showHeader: false,
                        business: _ctx.business
                      }, null, 8, ["business"])
                    ]),
                    (_ctx.business.about)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _cache[5] || (_cache[5] = _createElementVNode("div", { "m-t-3": "" }, null, -1)),
                          _createVNode(_component_app_section_divider, { content: "Description" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_OpportunityBulb)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_ctx.business.about)
                            ? (_openBlock(), _createBlock(_component_app_truncate, {
                                key: 0,
                                style: {"font-size":"14px"},
                                content: _ctx.business.about,
                                max: 4000,
                                "m-tb-0": ""
                              }, null, 8, ["content"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_app_user_section, { style: {"margin-top":"16px"} }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_app_section_divider, { content: `Founders'profiles` }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "el-icon-user" }, null, -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_appStartupUsersList, { business: _ctx.business }, null, 8, ["business"])
                    ])
                  ])
                ]),
                _: 1
              }),
              (_ctx.business !== undefined && _ctx.user.type === 'founder')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_BusinessUpdateModal, {
                      onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEditing = false)),
                      business: _ctx.business,
                      isModalOpen: _ctx.isEditing,
                      onUpdate: _ctx.updatedBusiness
                    }, null, 8, ["business", "isModalOpen", "onUpdate"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    right: _withCtx(() => [
      _createVNode(_component_app_right_nav, null, {
        default: _withCtx(() => [
          _createVNode(_component_app_business_right_nav),
          _createVNode(_component_app_opportunities_list_nav)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}